import { render, staticRenderFns } from "./information_page.vue?vue&type=template&id=3f610860&scoped=true"
import script from "./information_page.vue?vue&type=script&lang=js"
export * from "./information_page.vue?vue&type=script&lang=js"
import style0 from "./information_page.vue?vue&type=style&index=0&id=3f610860&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f610860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f610860')) {
      api.createRecord('3f610860', component.options)
    } else {
      api.reload('3f610860', component.options)
    }
    module.hot.accept("./information_page.vue?vue&type=template&id=3f610860&scoped=true", function () {
      api.rerender('3f610860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/website/information_page.vue"
export default component.exports